"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var PsigateDepositWorkflowComponent = /*#__PURE__*/function (_React$Component) {
  function PsigateDepositWorkflowComponent() {
    _classCallCheck(this, PsigateDepositWorkflowComponent);
    return _callSuper(this, PsigateDepositWorkflowComponent, arguments);
  }
  _inherits(PsigateDepositWorkflowComponent, _React$Component);
  return _createClass(PsigateDepositWorkflowComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.form.submit();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var options = this.props.options;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Redirecting to Psigate..."), /*#__PURE__*/_react["default"].createElement("form", {
        id: "psigateForm",
        style: {
          visibility: 'hidden'
        },
        action: options.APIAddress,
        method: "post",
        ref: function ref(form) {
          return _this.form = form;
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        name: "MerchantID",
        type: "text",
        value: options.MerchantID
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "PaymentType",
        type: "text",
        value: options.PaymentType
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "OrderID",
        type: "text",
        value: options.OrderID
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "UserID",
        type: "text",
        value: options.UserID
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "SubTotal",
        type: "text",
        value: options.SubTotal
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "CardAction",
        type: "text",
        value: 0
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "ResponseFormat",
        type: "text",
        value: options.ResponseFormat
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "Email",
        type: "text",
        value: options.Email
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "ThanksURL",
        type: "text",
        value: options.ThanksURL
      }), /*#__PURE__*/_react["default"].createElement("input", {
        name: "NoThanksURL",
        type: "text",
        value: options.NoThanksURL
      })));
    }
  }]);
}(_react["default"].Component);
PsigateDepositWorkflowComponent.defaultProps = {
  options: {
    MerchantID: '',
    PaymentType: '',
    OrderID: '',
    UserID: '',
    SubTotal: '',
    ResponseFormat: '',
    Email: ''
  }
};
PsigateDepositWorkflowComponent.propTypes = {
  options: _propTypes["default"].shape({
    MerchantID: _propTypes["default"].string,
    PaymentType: _propTypes["default"].string,
    OrderID: _propTypes["default"].string,
    UserID: _propTypes["default"].string,
    SubTotal: _propTypes["default"].string,
    ResponseFormat: _propTypes["default"].string,
    Email: _propTypes["default"].string
  })
};
var _default = exports["default"] = PsigateDepositWorkflowComponent;